<template>
  <div class="info-frame">
    <close-website-button
      :is-content-element="false"
      @close="$emit('close')"
    />
    <iframe
      :src="infoUrl"
      class="frame"
    >
      Your browser does not support frames
    </iframe>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import CloseWebsiteButton from '@/components/CloseWebsiteButton.vue';

export default defineComponent({
  name: 'InfoUrlFrameComponent',
  components: { CloseWebsiteButton },

  emits: ['close'],

  props: {
    infoUrl: {
      type: String,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
.info-frame {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background-color: #fff;

  .frame {
    border: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
}
</style>
